<template lang="pug">
.tip
  .tip-cover(v-if="cover")
  dl.tip-info(v-if="cover")
    dt {{title}}
    dd(v-if="desc") {{desc}}
  .tip-text(v-else) {{title}}
</template>
<script>
export default {
  name: 'Tip',
  props: {
    cover: Boolean,
    title: String,
    desc: String,
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common"
@import "src/styles/footprint"
.tip
  +full; z-index: 9999; position: fixed
  +flex-center
.tip-cover
  +full; background: rgba(0, 0, 0, 0.55)
.tip-info
  position: relative; z-index: 1
  width: pxRes(353); background: #FFFFFF; border-radius: pxRes(9)
  color: #333333; padding: pxRes(26) 0; text-align: center
  dt
    +text(20, 28); font-weight: 600
  dd
    +text(16, 22); padding: pxRes(4) pxRes(24) 0; color: #1677FF; margin: 0
.tip-text
  position: relative; z-index: 1
  width: pxRes(334); background: rgba(0, 0, 0, 0.8); border-radius: pxRes(18)
  color: #FFFFFF; padding: pxRes(22) 0; text-align: center
  +text(20, 28); font-weight: 600
</style>
